import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIADTargets = {
    name: 'Add Target Screen',
    imageUrl: '../../images/ADTargets.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIADNewtarget = {
    name: 'User Form',
    imageUrl: '../../images/ADNewtarget.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADNetdisco = {
    name: 'User Form',
    imageUrl: '../../images/ADNetdisco.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADNewdisco = {
    name: 'User Form',
    imageUrl: '../../images/ADNewdisco.png',
    imageSize: "99%",
    bradius: 20,
  };

export const ADTargets = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Target Management</b><br/><br/>
      CYRISMA will discover, identify, and scan any device on any network where that network 
      has at least one agent installed. A network device can be a printer, camera, phone, router, 
      or any local IP addressable device. Targets are the foundation of <b>authenticated</b> scanning. <br/><br/>
      <i><b>Targets</b> are computer servers or workstations running an Operating System such as Windows, Linux, or MacOS. </i><br/><br/>
      <b>Target Status Overview</b><br/><br/>
      The “Target Status Overview” provides a quick snapshot of the number of Targets covered 
      by your instance and their scan status and patch information. View complete lists of 
      Agents/Total Targets, Unscanned Targets, Patched Targets, Target Scanned Summary or 
      Network Assets by clicking on the relevant tab (in blue). You also have the option to 
      view Targets by Operating System.<br/><br/>
      <b>Targets can be added several ways</b><br/><br/>
      <ol style={{marginLeft: '4em'}}>
      <li>Manually (one at a time) </li>
      <li>Via bulk upload using a CSV file with the target details included in the CSV File. </li>
      <li>Network Discovery scan. For discovery scans, an agent is set up on one target within 
      the network subnet, and that agent is then used to perform the discovery scan. New 
      targets can be added from the discovery results by selecting them and importing them. </li></ol><br/>
      Deploy agents on all target machines (using Domain Group Policy script, PowerShell 
      script, or other Remote Management tool). As agents are distributed and deployed to target 
      machines, they can be accepted using the "Scan Agent -&gt; New Agent" feature. See help 
      documentation under "Admin -&gt; Scan Agents" for more detail.
      </div>
      <div style={helpimg}>
      <img
        src={UIADTargets.imageUrl}
        alt={'Image of ' + UIADTargets.name}
        style={{
          width: UIADTargets.imageSize,
          borderRadius: UIADTargets.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADNewtarget = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Add New Target</b><br/><br/>
      Use the <b>Add New Target</b> button to manually add a new target. It is recommended that this be 
      used on the occasion when a target or a very small number of targets are manually 
      added to the system.<br/><br/>
      The following information about the target is needed: <br/><br/>
      <b>Host Name:</b> The host name understood by the operating system and network where this target is running. <br/><br/>
      <b>Host FQDN:</b> The fully qualified host and domain name. <br/><br/>
      <b>IP Address:</b> The internal, local IP address for this target machine. <br/><br/>
      <b>Machine Hardware ID:</b> Generally, the target machine’s local Bios Serial number is given by 
      the manufacturer. This number may be obtained by using an administrative command prompt and 
      entering the command: "wmic bios get serialnumber". <br/><br/>
      <b>On Domain:</b> Switch to indicate whether this target machine is a member of an Active Directory Domain or not. <br/><br/>
      <b>Data Scan Locations:</b> List of default network shares or local disk scan locations. <i>This field may be left blank.</i> <br/><br/>
      <b>Defined Type:</b> Unless otherwise directed by CYRISMA support, this should always be "File Share". <br/><br/>
      <b>Operating System:</b> All target machines must be running a supported operating system from the dropdown here. 
      If the target OS is NOT included in this dropdown, do not add this target. Instead, it will be scanned as a local 
      IP addressable object during <b>unauthenticated</b> scanning. <br/><br/>
      <b>SQL Authentication:</b> Unless otherwise directed by CYRISMA support, this should always be "Not Required". <br/><br/>
      <b>Vulnerability Profile:</b> The vulnerability profile most closely matches the target machine’s OS. 
      A profile for an OS different from the installed OS will perform a scan, but no results will be returned. 
      The vulnerability profile of the OS must match the OS running on the target machine. <br/><br/>
      <b>Secure Baseline Profile:</b> The secure baseline configuration profile that most closely matches the 
      target machine’s OS. This setting has two parts. Once the profile has been selected, select a sub-profile 
      within the selected profile that most closely matches the target machine configuration and purpose. <br/><br/>
      <b>File Integrity Profile:</b> Select Windows or Linux according to the target OS, otherwise select "Not Required". <br/><br/>
      <b>Target Status:</b> New targets are entered as "Enabled". Existing targets can be "Disabled" or "Deleted". <br/><br/>
      <b>Information Fields:</b> As targets are scanned, the scan result will include <b>OS End of Life, Security 
      Applications</b> and any <b>Open Ports</b> discovered. 
      </div>
      <div style={helpimg}>
      <img
        src={UIADNewtarget.imageUrl}
        alt={'Image of ' + UIADNewtarget.name}
        style={{
          width: UIADNewtarget.imageSize,
          borderRadius: UIADNewtarget.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADNetdisco = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Network Discovery</b><br/><br/>
      Use the Network Discovery button to scan an IP subnet that includes target machines. 
      The results show all IP devices discovered, and target machines with a supported OS 
      will be included in the result. <br/><br/>
      Click on a scan name to see discovered targets. (If no previous network discovery 
      scan result exists, see the section: "New Network Discovery Scans"). <br/><br/>
      Network Discovery creates target lists that can easily be merged into the system 
      so that all other scan types can be performed. Targets can be scanned for Data 
      Sensitivity content, Vulnerabilities, and System Configuration.
      </div>
      <div style={helpimg}>
      <img
        src={UIADNetdisco.imageUrl}
        alt={'Image of ' + UIADNetdisco.name}
        style={{
          width: UIADNetdisco.imageSize,
          borderRadius: UIADNetdisco.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADNewdisco = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>New Network Discovery Scans</b><br/><br/>
      To perform a new network discovery scan, use the Network Discovery button, 
      and then on the "Network Discovery Scanner" page, hit "Add New". <br/><br/>
      The "Network Discovery Scheduler" screen will be presented. <br/><br/>
      Each section must be completed: <br/><br/>
      <b>Scan Name:</b> Enter a scan name to identify this specific scan. <br/><br/>
      <b>IP Address:</b> Enter an IP address or range of addresses to include in this scan. 
      Slash subnet notation is supported. However, please understand that a small subnet 
      mask could represent tens of thousands of IPs to scan. It is better to break 
      scans into manageable segments based on what is known about the network topology. 
      The best approach is to tailor the IP scope to match what is known about the 
      network and specify scopes to match the network design. <br/><br/>
      <b>Credential to be Used:</b> The Sensor (or Agent) will require a credential to connect, 
      log in, identify OS information, and file shares. IP devices that cannot be logged 
      into will NOT be included in the list of devices that can be merged as targets. 
      The agent can use either its configured default credential (which was set when 
      the agent was initially configured) or a separate credential entered here that 
      will be used at scan time instead of the configured default. Use a credential 
      that is likely to allow the agent full access to target machines in the network 
      segment subnet. <br/><br/>
      <b>Scan Schedule:</b> Select "Now" or set up a future date or recurring schedule for this scan. <br/><br/>
      Scan Complete Notification: OPTIONAL: Select a recipient to receive the scan completion 
      email notification. <br/><br/>
      <b>Select a Sensor:</b> Choose an agent from a list of previously installed agents to 
      act as the sensor to perform this local discovery scan. <br/><br/>
      When all fields have been completed, <b>Submit the scan</b>. Scan time will depend on the 
      number of IP devices included in the "IP Address" field during scan configuration.  
      </div>
      <div style={helpimg}>
      <img
        src={UIADNewdisco.imageUrl}
        alt={'Image of ' + UIADNewdisco.name}
        style={{
          width: UIADNewdisco.imageSize,
          borderRadius: UIADNewdisco.bradius,
        }}
      />
      </div>
    </div>
  );
};
